// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  height: 68px;
  width: 50%;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 2px solid #cccccc;
  border-radius: 36px;
  background-color: #ffffff;
}

@media (max-width: 900px) {
  .search-bar {
    width: 80%;
  }
}
@media (max-width: 500px) {
  .search-bar {
    width: 95%;
  }
}
.keyboard-icon {
  color: #999999;
  height: 26px;
  padding: 5px 10px 0px 20px;
  align-items: center;
  justify-content: center;
}

@media (max-width: 500px) {
  .keyboard-icon {
    margin-left: 10px;
  }
}

.text-input {
  flex: 1 1;
  border: none;
  padding: 5px;
  font-family: Roboto;
  font-size: 22px;
  outline: none;
}

.filter-styles-control {
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 36px;
  margin-right: 0.7em;
}

.filter-styles-placeholder {
  font-size: 1em;
  font-weight: 400;
}

.filter-styles-option {
  background-color: #e5e5e5;
  color: #ffffff;
}

.option-arrow {
  color: #cc0000;
  height: 16px;
}

.semantic-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 16px;
  font-family: Roboto;
  font-size: 16px;
  color: #333333;
}

.semantic-toggle input {
  width: 18px;
  height: 18px;
}

.search-icon {
  align-items: center;
  justify-content: end;
  color: #cc0000;
  height: 20px;
  padding-right: 20px;
}

.left-up-arrow {
  color: #808080;
  height: 12px;
  margin-right: 10px;
}

@media (max-width: 650px) {
  .left-up-arrow {
    display: none;
  }
}

.text-below-search-box-div {
  display: flex;
  color: #808080;
  font-size: 14px;
  line-height: 150%;
  height: 24px;
  font-family: Roboto-Slab;
  font-style: normal;
  font-weight: 400;
  justify-content: flex-start;
  margin-top: 0;
  width: 50%;
  padding-left: 28px; /* Match keyboard icon padding, shifted slightly right */
}

@media (max-width: 900px) {
  .text-below-search-box-div {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .text-below-search-box-div {
    width: 95%;
    padding-left: 10px; /* Match keyboard icon margin on mobile */
  }
}

.search-div {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 60px;
}

.arrow-container-div {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 0;
}

/* Autocomplete */

.below-input {
  position: relative;
}

/* .autocomplete-div {
  margin-left: 25em;
  position: absolute;
  width: 50%;
  z-index: 100;
  top: 5%;
  left: 0;
} */
.autocomplete-div {
  margin-left: auto;
  margin-right: auto;
  left: 77%;
  transform: translateX(-96%);
  position: absolute;
  z-index: 100;
  width: 50%;
}

.autocomplete-suggestions {
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  position: absolute;
  z-index: 1000;
  width: 50%;
  border: 1px solid #cccccc;
  border-top: none;
  max-height: 300px;
  overflow-y: auto;
}

.suggestion-item {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
  cursor: pointer;
}

.suggestion-item:hover {
  background-color: #f2f2f2;
}

@media (max-width: 900px) {
  .autocomplete-suggestions {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .autocomplete-suggestions {
    width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/search-input.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,kBAAkB,EAAE,wDAAwD;AAC9E;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB,EAAE,yCAAyC;EAC/D;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;AACpB;;AAEA;;;;;;;GAOG;AACH;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".search-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: visible;\n  height: 68px;\n  width: 50%;\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 2px solid #cccccc;\n  border-radius: 36px;\n  background-color: #ffffff;\n}\n\n@media (max-width: 900px) {\n  .search-bar {\n    width: 80%;\n  }\n}\n@media (max-width: 500px) {\n  .search-bar {\n    width: 95%;\n  }\n}\n.keyboard-icon {\n  color: #999999;\n  height: 26px;\n  padding: 5px 10px 0px 20px;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 500px) {\n  .keyboard-icon {\n    margin-left: 10px;\n  }\n}\n\n.text-input {\n  flex: 1;\n  border: none;\n  padding: 5px;\n  font-family: Roboto;\n  font-size: 22px;\n  outline: none;\n}\n\n.filter-styles-control {\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  border-radius: 36px;\n  margin-right: 0.7em;\n}\n\n.filter-styles-placeholder {\n  font-size: 1em;\n  font-weight: 400;\n}\n\n.filter-styles-option {\n  background-color: #e5e5e5;\n  color: #ffffff;\n}\n\n.option-arrow {\n  color: #cc0000;\n  height: 16px;\n}\n\n.semantic-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 16px;\n  font-family: Roboto;\n  font-size: 16px;\n  color: #333333;\n}\n\n.semantic-toggle input {\n  width: 18px;\n  height: 18px;\n}\n\n.search-icon {\n  align-items: center;\n  justify-content: end;\n  color: #cc0000;\n  height: 20px;\n  padding-right: 20px;\n}\n\n.left-up-arrow {\n  color: #808080;\n  height: 12px;\n  margin-right: 10px;\n}\n\n@media (max-width: 650px) {\n  .left-up-arrow {\n    display: none;\n  }\n}\n\n.text-below-search-box-div {\n  display: flex;\n  color: #808080;\n  font-size: 14px;\n  line-height: 150%;\n  height: 24px;\n  font-family: Roboto-Slab;\n  font-style: normal;\n  font-weight: 400;\n  justify-content: flex-start;\n  margin-top: 0;\n  width: 50%;\n  padding-left: 28px; /* Match keyboard icon padding, shifted slightly right */\n}\n\n@media (max-width: 900px) {\n  .text-below-search-box-div {\n    width: 80%;\n  }\n}\n\n@media (max-width: 500px) {\n  .text-below-search-box-div {\n    width: 95%;\n    padding-left: 10px; /* Match keyboard icon margin on mobile */\n  }\n}\n\n.search-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 60px;\n}\n\n.arrow-container-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 0;\n}\n\n/* Autocomplete */\n\n.below-input {\n  position: relative;\n}\n\n/* .autocomplete-div {\n  margin-left: 25em;\n  position: absolute;\n  width: 50%;\n  z-index: 100;\n  top: 5%;\n  left: 0;\n} */\n.autocomplete-div {\n  margin-left: auto;\n  margin-right: auto;\n  left: 77%;\n  transform: translateX(-96%);\n  position: absolute;\n  z-index: 100;\n  width: 50%;\n}\n\n.autocomplete-suggestions {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: white;\n  position: absolute;\n  z-index: 1000;\n  width: 50%;\n  border: 1px solid #cccccc;\n  border-top: none;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.suggestion-item {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n  cursor: pointer;\n}\n\n.suggestion-item:hover {\n  background-color: #f2f2f2;\n}\n\n@media (max-width: 900px) {\n  .autocomplete-suggestions {\n    width: 80%;\n  }\n}\n\n@media (max-width: 500px) {\n  .autocomplete-suggestions {\n    width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
